//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const relatorioExamesService = {
  findAll,
  doGet,
  findByFiltro,
};

function findAll() {
  return defaultService.doGet(`${urlsConstants.RELATORIO_EXAMES}findAll`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.RELATORIO_EXAMES}${id}`);
}

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.RELATORIO_EXAMES}list`,
    options,
    filter
  );
}
